import React from 'react';

import { webCampaign } from '@/modules/webCampaign';

import { useColorScheme } from './useColorScheme';

export const useBrowserContentColor = () => {
  const { theme } = useColorScheme();

  React.useEffect(() => {
    if (theme === 'dark') {
      // Change theme color
      const themeColorAttribute = document.querySelector(
        'meta[name=theme-color]',
      );
      if (themeColorAttribute) {
        const staticTheme = webCampaign.getStaticTheme();

        switch (staticTheme) {
          case 'dark-violet':
            themeColorAttribute.setAttribute('content', '#43285B');
            break;
          case 'domination':
            themeColorAttribute.setAttribute('content', '#030101');
            break;
          case 'purple-gradient':
            themeColorAttribute.setAttribute('content', '#C6399A');
            break;
          default:
            themeColorAttribute.setAttribute('content', '#1e0f34');
            break;
        }
      }
    }
  }, [theme]);
};
